module.exports = __webpack_public_path__ + "static/media/shoes.184cff57.png";